export { default } from './AcceptContract';
